
<div class="shm-wrap" [class.shm-wrap--alt]="variant === 'alt'">

  <!-- Header: métricas + toggle vista (oculto cuando detalle expandido) -->
  <div class="shm-header" [class.shm-header--hidden]="!!selectedStore && detailExpanded">

    <!-- Fila: KPIs estratégicos + toggle -->
    <div class="shm-metrics-row">
      <div class="shm-kpi-grid">

        <!-- Caras Postobón -->
        <button class="shm-kpi shm-kpi--ptbn"
                [class.is-active]="metric==='face'"
                (click)="setMetric('face')">
          <div class="shm-kpi__head">
            <span class="shm-kpi__dot shm-kpi__dot--ptbn"></span>
            <span class="shm-kpi__label">Caras PTBN</span>
          </div>
          <strong class="shm-kpi__value">{{ formatCompact(metricTotalPtbn) }}</strong>
          <span class="shm-kpi__sub">{{ sharePtbnPct.toFixed(1) }}% del total</span>
        </button>

        <!-- Caras CCX -->
        <button class="shm-kpi shm-kpi--ccx"
                [class.is-active]="metric==='contaminant'"
                (click)="setMetric('contaminant')">
          <div class="shm-kpi__head">
            <span class="shm-kpi__dot shm-kpi__dot--ccx"></span>
            <span class="shm-kpi__label">Caras CCX</span>
          </div>
          <strong class="shm-kpi__value">{{ formatCompact(metricTotalCcx) }}</strong>
          <span class="shm-kpi__sub">{{ shareCcxPct.toFixed(1) }}% del total</span>
        </button>

        <!-- Share Postobón vs CCX -->
        <div class="shm-kpi shm-kpi--share">
          <div class="shm-kpi__head">
            <i class="pi pi-chart-pie" style="font-size:11px;color:#4f46e5"></i>
            <span class="shm-kpi__label">Participación PTBN</span>
          </div>
          <strong class="shm-kpi__value">{{ sharePtbnPct.toFixed(0) }}%</strong>
          <div class="shm-share-bar">
            <div class="shm-share-bar__ptbn" [style.width.%]="sharePtbnPct"></div>
            <div class="shm-share-bar__ccx"  [style.width.%]="shareCcxPct"></div>
          </div>
        </div>

        <!-- Vacíos -->
        <button class="shm-kpi shm-kpi--empty"
                [class.is-active]="metric==='empty'"
                (click)="setMetric('empty')">
          <div class="shm-kpi__head">
            <i class="pi pi-stop" style="font-size:11px;color:#d97706"></i>
            <span class="shm-kpi__label">Vacíos</span>
          </div>
          <strong class="shm-kpi__value">{{ metricTotalEmpty }}</strong>
          <span class="shm-kpi__sub">espacios detectados</span>
        </button>

        <!-- PDV seleccionados -->
        <div class="shm-kpi shm-kpi--pdv">
          <div class="shm-kpi__head">
            <i class="pi pi-map-marker" style="font-size:11px;color:#0ea5e9"></i>
            <span class="shm-kpi__label">PDV en vista</span>
          </div>
          <div class="shm-pdv-count">
            <strong class="shm-pdv-count__main">{{ filteredCount }}</strong>
            <span class="shm-pdv-count__total">/ {{ totalCount }}</span>
          </div>
          @if (selectedLocality) {
            <span class="shm-kpi__sub shm-pdv-filter" (click)="clearLocalityFilter()">
              {{ selectedLocality }} <i class="pi pi-times"></i>
            </span>
          } @else {
            <span class="shm-kpi__sub">puntos de venta</span>
          }
        </div>

      </div>
      <div class="shm-header-end">
        <div class="shm-mode-toggle">
          <button [class.active]="viewMode==='heat'"    (click)="setMode('heat')"    title="Calor"><i class="pi pi-th-large"></i></button>
          <button [class.active]="viewMode==='markers'" (click)="setMode('markers')" title="Marcadores"><i class="pi pi-map-marker"></i></button>
        </div>
      </div>
    </div>

  </div>

  <!-- Body: mapa + panel lateral — el div .shm-map SIEMPRE existe para que Leaflet pueda inicializarse -->
  <div class="shm-body"
       [class.shm-body--mini]="!!selectedStore && !detailExpanded"
       [class.shm-body--hidden]="!!selectedStore && detailExpanded">
    <div class="shm-map-container">
      <div #mapEl class="shm-map"></div>

      <!-- Overlay de carga mientras el query 435 responde -->
      @if (loading) {
        <div class="shm-loading-overlay">
          <div class="shm-dp-spinner"></div>
          <span>Cargando tiendas…</span>
        </div>
      }

      <!-- ⭐ Dynamic Island: City + Type + Search -->
      <div class="shm-dynamic-island" (mouseleave)="showSearchDropdown = false">
        <div class="shm-di-wrap">
          <!-- City Selector -->
          <div class="shm-di-city">
            <i class="pi pi-map"></i>
            <select [ngModel]="selectedCity" (ngModelChange)="onCityChange($event)">
              <option value="all">Todas las ciudades</option>
              @for (c of cities; track c) {
                <option [value]="c">{{ c }}</option>
              }
            </select>
          </div>
          
          <div class="shm-di-divider"></div>

          <!-- Type Selector -->
          <div class="shm-di-type">
            <select [(ngModel)]="searchType" (ngModelChange)="onSearchTypeChange($event)">
              <option value="store">Tienda</option>
              <option value="product">Producto</option>
            </select>
          </div>

          <div class="shm-di-divider"></div>

          <!-- Search Input -->
          <div class="shm-di-search">
            <i class="pi pi-search"></i>
            <input type="text"
                   [placeholder]="searchType === 'store' ? 'Buscar tienda...' : 'Buscar producto...'"
                   [ngModel]="searchQuery"
                   (ngModelChange)="onSearchChange($event)"
                   (focus)="showSearchDropdown = searchQuery.length > 0" />
            @if (searchQuery) {
              <button class="shm-di-clear" (click)="clearSearch()"><i class="pi pi-times"></i></button>
            }
          </div>
        </div>
        
        <!-- Search Dropdown -->
        <!-- Dropdown: tiendas -->
        @if (showSearchDropdown && searchType === 'store' && searchDropdownResults.length > 0) {
          <div class="shm-di-dropdown">
            @for (res of searchDropdownResults; track res.name) {
              <button class="shm-di-result" (click)="selectStoreFromSearch(res)">
                <div class="shm-di-result-icon">
                  <span class="shm-di-loc-dot" [style.background]="localityColor(res.locality)"></span>
                </div>
                <div class="shm-di-result-info">
                  <strong>{{ res.name }}</strong>
                  <span>{{ res.locality }}</span>
                </div>
                <div class="shm-di-result-score">
                  <span class="shm-di-badge" [class.is-good]="res.avgScore > 0.8" [class.is-bad]="res.avgScore < 0.6">
                    {{ (res.avgScore * 100).toFixed(0) }}%
                  </span>
                </div>
              </button>
            }
          </div>
        }
        @if (showSearchDropdown && searchType === 'store' && searchDropdownResults.length === 0 && searchQuery.length > 0) {
          <div class="shm-di-dropdown">
            <div class="shm-di-empty">
              <i class="pi pi-exclamation-circle"></i>
              <span>No se encontraron tiendas</span>
            </div>
          </div>
        }

        <!-- Dropdown: productos del catálogo (query 436) -->
        @if (showSearchDropdown && searchType === 'product' && productDropdownResults.length > 0) {
          <div class="shm-di-dropdown">
            @for (prod of productDropdownResults; track prod.id) {
              <button class="shm-di-result shm-di-result--product" (click)="selectProductFromSearch(prod)">
                <div class="shm-di-result-icon">
                  <i class="pi pi-box" style="font-size:12px;color:#6366f1"></i>
                </div>
                <div class="shm-di-result-info">
                  <strong>{{ prod.name }}</strong>
                  <span>ID {{ prod.id }}</span>
                </div>
                <div class="shm-di-result-score">
                  <span class="shm-di-badge">
                    {{ storeCountForProduct(prod.id) }} PDV
                  </span>
                </div>
              </button>
            }
          </div>
        }
        @if (showSearchDropdown && searchType === 'product' && productDropdownResults.length === 0 && searchQuery.length > 0) {
          <div class="shm-di-dropdown">
            <div class="shm-di-empty">
              <i class="pi pi-exclamation-circle"></i>
              <span>No se encontraron productos</span>
            </div>
          </div>
        }

        <!-- Chip del filtro de producto activo -->
        @if (searchType === 'product' && selectedProductId != null) {
          <div class="shm-di-active-product">
            <i class="pi pi-filter-fill" style="font-size:11px;color:#6366f1"></i>
            <span class="shm-di-active-product__name">{{ selectedProductName }}</span>
            <span class="shm-di-active-product__count">{{ filteredStores.length }} PDV</span>
            <button type="button" (click)="clearSearch()" title="Quitar filtro">
              <i class="pi pi-times"></i>
            </button>
          </div>
        }
      </div>

      @if (!stores.length && !loading) {
        <div class="shm-empty shm-empty--overlay">
          <strong>Sin datos geográficos</strong>
          <span>No hay tiendas para el filtro actual.</span>
        </div>
      }
      @if (variant === 'alt' && viewMode === 'heat') {
        <div class="shm-legend">
          <span>Bajo</span>
          <div class="shm-legend__bar"></div>
          <span>Alto</span>
        </div>
      }


      <!-- Tooltip flotante compacto. Posición ajustada para no salirse del mapa
           (siempre dentro de bounds, usa flip arriba/abajo según haya espacio) -->
      @if (tooltip) {
        <div class="shm-tooltip"
             [class.shm-tooltip--flip-down]="tooltip.flipDown"
             [class.shm-tooltip--flip-left]="tooltip.flipLeft"
             [class.shm-tooltip--flip-right]="tooltip.flipRight"
             [style.left.px]="tooltip.x"
             [style.top.px]="tooltip.y">
          <div class="shm-tt-name">{{ tooltip.store.name }}</div>
          <div class="shm-tt-row">
            <span class="shm-tt-dot" [style.background]="localityColor(tooltip.store.locality)"></span>
            <span class="shm-tt-locality">{{ tooltip.store.locality }}</span>
            <span class="shm-tt-visits">
              <i class="pi pi-eye"></i> {{ tooltip.store.visits }}
            </span>
          </div>
        </div>
      }
    </div>

    <!-- Panel lateral removido para permitir mapa 100% -->
  </div>

  <!-- ── Detalle inline de punto de venta ── -->
  @if (selectedStore) {
    <div class="shm-detail-panel">

      <!-- Cabecera del PDV — diseño en 2 filas con info rica + KPIs en su fila -->
      <div class="shm-dp-head">

        <!-- Fila 1: nombre + acciones, metadata abajo -->
        <div class="shm-dp-head__top">
          <span class="shm-dp-dot" [style.background]="localityColor(selectedStore.locality)"></span>
          <div class="shm-dp-info">
            <strong class="shm-dp-name">{{ selectedStore.name }}</strong>
            <div class="shm-dp-meta">
              @if (storeAddress) {
                <span class="shm-dp-meta-item">
                  <i class="pi pi-map-marker"></i>
                  {{ storeAddress }}
                </span>
              }
              <span class="shm-dp-meta-item">
                <i class="pi pi-globe"></i>
                {{ selectedStore.locality }}@if (selectedStore.city && selectedStore.city !== selectedStore.locality) {, {{ selectedStore.city }}}
              </span>
              <span class="shm-dp-meta-item shm-dp-meta-item--mono">
                {{ selectedStore.lat.toFixed(4) }}, {{ selectedStore.lng.toFixed(4) }}
              </span>
              @if (storeLastVisit) {
                <span class="shm-dp-meta-item">
                  <i class="pi pi-calendar"></i>
                  Última: {{ storeLastVisit }}
                </span>
              }
              @if (storeTotalVisits) {
                <span class="shm-dp-meta-item">
                  <i class="pi pi-history"></i>
                  {{ storeTotalVisits }} visitas
                </span>
              }
            </div>
          </div>
          <button class="shm-dp-action"
                  (click)="toggleDetailExpanded()"
                  [title]="detailExpanded ? 'Restaurar mapa' : 'Expandir detalle (ocultar mapa)'">
            <i class="pi" [class.pi-window-maximize]="!detailExpanded" [class.pi-window-minimize]="detailExpanded"></i>
          </button>
          <button class="shm-dp-close" (click)="closeDetail()" title="Cerrar (ESC)">
            <i class="pi pi-times"></i>
          </button>
        </div>

        <!-- Fila 2: 3 KPIs principales basados en tags + barra de share -->
        <div class="shm-dp-kpis">
          <!-- Productos Postobón -->
          <div class="shm-dp-kpi shm-dp-kpi--ptbn">
            <svg class="shm-dp-kpi__icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <!-- botella de bebida -->
              <path d="M10 2h4v2.27l2.45 2.86A2 2 0 0117 8.55V20a2 2 0 01-2 2H9a2 2 0 01-2-2V8.55a2 2 0 01.55-1.38L10 4.27V2zm1.5 1.5v1.9L9 8.07V20h6V8.07l-2.5-2.67V3.5h-1zM9 11h6v1.5H9V11z"/>
            </svg>
            <span class="shm-dp-kpi__label">Prod. PTBN</span>
            <strong class="shm-dp-kpi__value">{{ formatCompact(detailFacesPtbn) }}</strong>
            <span class="shm-dp-kpi__tag">tag: postobon</span>
          </div>

          <!-- Competencia -->
          <div class="shm-dp-kpi shm-dp-kpi--ccx">
            <svg class="shm-dp-kpi__icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <!-- escudo / competidor -->
              <path d="M12 2l7 3v6c0 4.2-3 8.1-7 9-4-0.9-7-4.8-7-9V5l7-3zm0 2.18L7 6.5V11c0 3.18 2.2 6.15 5 7 2.8-.85 5-3.82 5-7V6.5l-5-2.32zm0 3.82a2.5 2.5 0 110 5 2.5 2.5 0 010-5z"/>
            </svg>
            <span class="shm-dp-kpi__label">Competencia</span>
            <strong class="shm-dp-kpi__value">{{ formatCompact(detailFacesCcx) }}</strong>
            <span class="shm-dp-kpi__tag">tag: competencia</span>
          </div>

          <!-- Vacíos -->
          <div class="shm-dp-kpi shm-dp-kpi--warn">
            <svg class="shm-dp-kpi__icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <!-- nevera / refrigerador -->
              <path d="M7 2a2 2 0 00-2 2v16a2 2 0 002 2h10a2 2 0 002-2V4a2 2 0 00-2-2H7zm0 2h10v7H7V4zm0 9h10v7H7v-7zm2-8v4h1.5V5H9zm0 9.5v3.5h1.5v-3.5H9z"/>
            </svg>
            <span class="shm-dp-kpi__label">Vacíos</span>
            <strong class="shm-dp-kpi__value">{{ detailEmptyCount }}</strong>
            <span class="shm-dp-kpi__tag">tag: vacios</span>
          </div>
        </div>

        <!-- Barra de share PTBN vs CCX (visual, reemplaza el chip Share%) -->
        @if (detailFacesPtbn + detailFacesCcx > 0) {
          <div class="shm-dp-share-row">
            <div class="shm-dp-share-bar">
              <div class="shm-dp-share-bar__ptbn"
                   [style.width.%]="detailFacesPtbn / (detailFacesPtbn + detailFacesCcx) * 100">
                @if (detailFacesPtbn > detailFacesCcx * 0.2) {
                  PTBN {{ (detailFacesPtbn / (detailFacesPtbn + detailFacesCcx) * 100).toFixed(0) }}%
                }
              </div>
              <div class="shm-dp-share-bar__ccx"
                   [style.width.%]="detailFacesCcx / (detailFacesPtbn + detailFacesCcx) * 100">
                @if (detailFacesCcx > detailFacesPtbn * 0.2) {
                  {{ (detailFacesCcx / (detailFacesPtbn + detailFacesCcx) * 100).toFixed(0) }}% CCX
                }
              </div>
            </div>
          </div>
        }
      </div>

      <!-- Tabs del detalle: Galería / Productos / Resumen -->
      <div class="shm-dp-store-tabs">
        <button class="shm-dp-store-tab"
                [class.is-active]="storeDetailTab === 'gallery'"
                (click)="storeDetailTab = 'gallery'">
          <i class="pi pi-images"></i> Galería
          <span class="shm-dp-store-tab__count">{{ detailImages.length }}</span>
        </button>
        <button class="shm-dp-store-tab"
                [class.is-active]="storeDetailTab === 'products'"
                (click)="storeDetailTab = 'products'">
          <i class="pi pi-tag"></i> Productos
          <span class="shm-dp-store-tab__count">{{ storeSummary.topProducts.length }}</span>
        </button>
        <!-- tab Resumen desactivado temporalmente
        <button class="shm-dp-store-tab"
                [class.is-active]="storeDetailTab === 'summary'"
                (click)="storeDetailTab = 'summary'">
          <i class="pi pi-chart-bar"></i> Resumen
        </button>
        -->
      </div>

      <!-- ══ TAB: GALERÍA ══ -->
      @if (storeDetailTab === 'gallery') {
      <div class="shm-dp-gallery-layout" [class.shm-dp-gallery-layout--expanded]="detailExpanded">

        <!-- ══ 70%: imagen grande + tira horizontal ══ -->
        <div class="shm-dp-viewer">
          @if ((detailsLoading || internalLoading) && !selectedDetailImage) {
            <div class="shm-dp-viewer__loading">
              <div class="shm-dp-spinner"></div>
              <span>Cargando reconocimientos del PDV…</span>
            </div>
          }
          @if (!(detailsLoading || internalLoading) || selectedDetailImage) {
          @if (selectedDetailImage; as focusImage) {

            <!-- TOOLBAR: toggle vista + chips de tags en la misma fila -->
            <div class="shm-dp-toolbar">

              <!-- Toggle Cajas / Heatmap -->
              <div class="shm-dp-tb-toggle">
                <button [class.is-active]="bboxViewMode === 'boxes'"
                        (click)="bboxViewMode = 'boxes'" title="Cajas">
                  <i class="pi pi-stop"></i>
                  <span>Cajas</span>
                </button>
                <button [class.is-active]="bboxViewMode === 'heatmap'"
                        (click)="bboxViewMode = 'heatmap'" title="Mapa de calor">
                  <i class="pi pi-th-large"></i>
                  <span>Heatmap</span>
                </button>
              </div>

              <!-- Slider oscurecimiento (solo en modo heatmap) -->
              @if (bboxViewMode === 'heatmap') {
                <div class="shm-dp-tb-darken">
                  <i class="pi pi-image" title="Imagen visible"></i>
                  <input type="range" min="0" max="100" step="5"
                         [(ngModel)]="heatDarken" class="shm-dp-tb-slider"
                         title="Oscurecimiento de la imagen" />
                  <i class="pi pi-eye-slash" title="Imagen oscura"></i>
                  <span class="shm-dp-tb-darken-val">{{ heatDarken }}%</span>
                </div>
              }

              <!-- Controles de zoom -->
              <div class="shm-dp-tb-zoom">
                <button type="button" (click)="zoomOut()" [disabled]="imgZoom <= 1" title="Alejar (rueda ↓)">
                  <i class="pi pi-minus"></i>
                </button>
                <span class="shm-dp-tb-zoom-val"
                      [class.shm-dp-tb-zoom-val--active]="imgZoom > 1"
                      (click)="resetZoom()"
                      [title]="imgZoom > 1 ? 'Click para restablecer zoom' : 'Usa la rueda del mouse o los botones'">
                  {{ imgZoom.toFixed(1) }}×
                </span>
                <button type="button" (click)="zoomIn()" [disabled]="imgZoom >= 5" title="Acercar (rueda ↑)">
                  <i class="pi pi-plus"></i>
                </button>
              </div>

            </div>

            <!-- INSPECTOR: fuera de la imagen para no taparla -->
            <div class="shm-dp-inspector-bar" [class.shm-dp-inspector-bar--active]="!!hoveredObj">
              @if (hoveredObj; as obj) {
                <span class="shm-dp-insp-tag" [style.background]="tagColor(obj.tag)">{{ obj.tag }}</span>
                <strong class="shm-dp-inspector-bar__name">{{ obj.objectName ?? obj.tag }}</strong>
                @for (a of hoveredObjAttrs; track a.label) {
                  <span class="shm-dp-insp-attr">
                    <span class="shm-dp-insp-attr__label">{{ a.label }}</span>
                    <span class="shm-dp-insp-attr__val">{{ a.value }}</span>
                  </span>
                }
                <div class="shm-dp-inspector-bar__score-wrap">
                  <div class="shm-dp-inspector-bar__score-fill"
                       [style.width.%]="(obj.score ?? 0) * 100"
                       [style.background]="tagColor(obj.tag)"></div>
                </div>
                <span class="shm-dp-inspector-bar__pct">{{ ((obj.score ?? 0) * 100).toFixed(0) }}%</span>
                @if (obj.bbox) {
                  <span class="shm-dp-inspector-bar__dim">#{{ (hoveredBboxIdx ?? 0) + 1 }} · {{ obj.bbox.width.toFixed(0) }}×{{ obj.bbox.height.toFixed(0) }}px</span>
                }
              } @else {
                <i class="pi pi-info-circle shm-dp-inspector-bar__hint-icon"></i>
                <span class="shm-dp-inspector-bar__hint">Pasa el cursor sobre una caja para ver el detalle</span>
                <span class="shm-dp-insp-stats__chip">{{ selectedImageTotalProducts }} detecciones</span>
              }
            </div>

            <!-- Imagen con bboxes O heatmap -->
            <div #imgWrap class="shm-dp-viewer__img-wrap"
                 [class.shm-dp-viewer__img-wrap--zoomed]="imgZoom > 1"
                 [class.shm-dp-viewer__img-wrap--panning]="isPanning"
                 (wheel)="onImgWheel($event, imgWrap)"
                 (mousedown)="onImgPanStart($event)"
                 (mousemove)="onImgPanMove($event)"
                 (mouseup)="onImgPanEnd()"
                 (mouseleave)="onImgPanEnd()">
              <div class="shm-dp-viewer__img-inner" [style.transform]="imgTransformStyle">
                <img [src]="focusImage.imageUrl" alt="" loading="lazy"
                     (load)="onDetailImgLoad($event, focusImage, imgWrap)" />

                @if (focusImage.imgW > 0) {
                  <!-- Render BBoxes: sorted por área DESC (grandes detrás, pequeños arriba) -->
                  @if (bboxViewMode === 'boxes') {
                    @for (item of sortedBboxes(focusImage); track item.idx) {
                      @if (item.obj.bbox && (inferenceScoreMin <= 0 || (item.obj.score ?? 1) >= inferenceScoreMin) && shouldRenderObject(item.obj)) {
                        <div class="shm-dp-bbox"
                             [class]="'shm-dp-bbox--' + (item.obj.tag | lowercase)"
                             [style.z-index]="item.zIndex"
                             [ngStyle]="detailBboxStyle(item.obj, focusImage)"
                             (mouseenter)="hoveredBboxIdx = item.idx"
                             (mouseleave)="hoveredBboxIdx = null">
                        </div>
                      }
                    }
                  }

                  <!-- HEATMAP: overlay oscuro + gradientes por color de tag -->
                  @if (bboxViewMode === 'heatmap') {
                    <div class="shm-dp-heat-darken" [style.opacity]="heatDarken / 100"></div>
                    <div class="shm-dp-heat-layer"
                         [class.shm-dp-heat-layer--focused]="isFilteringByTag">
                      @for (obj of focusImage.objects; track $index) {
                        @if (obj.bbox
                          && (inferenceScoreMin <= 0 || (obj.score ?? 1) >= inferenceScoreMin)
                          && shouldRenderObject(obj)) {
                          <div class="shm-dp-heat-dot"
                               [class]="'shm-dp-heat-dot--' + (obj.tag | lowercase)"
                               [ngStyle]="detailBboxStyle(obj, focusImage)">
                          </div>
                        }
                      }
                    </div>
                  }
                }
              </div>
            </div>

            <!-- Tira horizontal de miniaturas con flechas de scroll -->
            <div class="shm-dp-strip-wrap">
              @if (detailImages.length > 4) {
                <button class="shm-dp-strip-nav shm-dp-strip-nav--left"
                        type="button"
                        (click)="scrollStrip(stripEl, 'left')"
                        title="Anterior">
                  <i class="pi pi-chevron-left"></i>
                </button>
              }
              <div #stripEl class="shm-dp-strip">
                @for (img of detailImages; track img.key) {
                  <button type="button"
                          class="shm-dp-strip__item"
                          [class.is-active]="img.key === selectedDetailImageKey"
                          (click)="selectDetailImage(img.key)">
                    <img [src]="img.imageUrl" alt="" loading="lazy" />
                  </button>
                }
              </div>
              @if (detailImages.length > 4) {
                <button class="shm-dp-strip-nav shm-dp-strip-nav--right"
                        type="button"
                        (click)="scrollStrip(stripEl, 'right')"
                        title="Siguiente">
                  <i class="pi pi-chevron-right"></i>
                </button>
              }
            </div>

          } @else {
            <div class="shm-dp-viewer__empty">
              <i class="pi pi-image"></i>
              <span>Sin imágenes</span>
            </div>
          }
          }
        </div>

        <!-- ══ 30%: lista de objetos detectados ══ -->
        <aside class="shm-dp-inferences">

          <!-- Chips de tags — visibilidad de capas -->
          @if (inferencesByTag.length) {
            <div class="shm-tag-chips shm-tag-chips--sidebar">
              <button type="button"
                      class="shm-tag-chip shm-tag-chip--all"
                      [class.is-active]="!hasHiddenTags"
                      (click)="clearInferenceTab()"
                      title="Mostrar todos ({{ allInferencesTotalCount }})">
                <i class="pi pi-eye"></i>
                <span>{{ allInferencesTotalCount }}</span>
              </button>
              @for (group of inferencesByTag; track group.tag) {
                <button type="button"
                        class="shm-tag-chip"
                        [class.is-hidden]="isTagHidden(group.tag)"
                        [style.--tc]="tagColor(group.tag)"
                        (click)="toggleInferenceTag(group.tag)"
                        [title]="(isTagHidden(group.tag) ? 'Mostrar ' : 'Ocultar ') + group.tag + ' (' + group.totalCount + ')'">
                  <span class="shm-tag-chip__dot"></span>
                  <span class="shm-tag-chip__label">{{ group.tag | slice:0:4 }}</span>
                  <span class="shm-tag-chip__count">{{ group.totalCount }}</span>
                </button>
              }
            </div>
          }

          <!-- Buscador de productos -->
          <div class="shm-dp-inf-search">
            <i class="pi pi-search shm-dp-inf-search__icon"></i>
            <input type="text"
                   class="shm-dp-inf-search__input"
                   placeholder="Buscar producto…"
                   [ngModel]="productSearchQuery"
                   (ngModelChange)="productSearchQuery = $event"
                   autocomplete="off" />
            @if (productSearchQuery) {
              <button type="button" class="shm-dp-inf-search__clear"
                      (click)="clearProductSearch()" title="Limpiar búsqueda">
                <i class="pi pi-times"></i>
              </button>
              <span class="shm-dp-inf-search__count">{{ filteredInferenceProducts.length }}</span>
            }
          </div>

          <!-- Chip de aislamiento activo -->
          @if (isolatedProductKey) {
            <div class="shm-dp-inf-isolation-chip">
              <i class="pi pi-eye"></i>
              <span>{{ isolatedProductName }}</span>
              <button type="button" (click)="clearProductIsolation()" title="Restaurar todos">
                <i class="pi pi-times"></i>
              </button>
            </div>
          }

          <!-- Lista de productos del tag activo (expandibles → score) -->
          <div class="shm-dp-inf-list">
            @if (activeInferenceGroup; as group) {
              @for (prod of filteredInferenceProducts; track prod.key) {
                <div class="shm-dp-inf-prod-row"
                     [class.is-expanded]="expandedInferenceKeys.has(prod.key)"
                     [class.is-hidden-prod]="isProductHidden(prod.tag, prod.name)"
                     [class.is-highlighted]="isHighlightedProduct(prod.name)">
                  <button class="shm-dp-inf-prod-toggle"
                          type="button"
                          (click)="onProductRowClick(prod.tag, prod.name, prod.key)"
                          [class.is-isolated]="isolatedProductKey === prod.key"
                          [title]="isolatedProductKey === prod.key ? 'Viendo solo este producto — click para desaislar' : 'Click para ver solo este producto en la imagen'">
                    @if (isHighlightedProduct(prod.name)) {
                      <i class="pi pi-filter-fill shm-dp-inf-prod-highlight-icon"></i>
                    } @else if (isolatedProductKey === prod.key) {
                      <i class="pi pi-eye" style="color:#6366f1"></i>
                    } @else {
                      <i class="pi" [class.pi-chevron-right]="!expandedInferenceKeys.has(prod.key)"
                                    [class.pi-chevron-down]="expandedInferenceKeys.has(prod.key)"></i>
                    }
                    <span class="shm-dp-inf-prod-name">{{ prod.name }}</span>
                    <span class="shm-dp-inf-prod-count" [style.color]="tagColor(prod.tag)">{{ prod.count }}</span>
                  </button>
                  <button class="shm-dp-inf-prod-eye"
                          type="button"
                          (click)="toggleProductVisibility(prod.tag, prod.name, $event)"
                          [title]="isProductHidden(prod.tag, prod.name) ? 'Mostrar ' + prod.name : 'Ocultar ' + prod.name">
                    <i class="pi" [class.pi-eye]="!isProductHidden(prod.tag, prod.name)"
                                  [class.pi-eye-slash]="isProductHidden(prod.tag, prod.name)"></i>
                  </button>
                </div>

                @if (expandedInferenceKeys.has(prod.key)) {
                  @for (item of prod.items; track item.objIndex) {
                    <div class="shm-dp-inf-item-row"
                         (mouseenter)="hoveredBboxIdx = item.objIndex"
                         (mouseleave)="hoveredBboxIdx = null">
                      <span class="shm-dp-inf-item-idx">#{{ item.objIndex + 1 }}</span>
                      <div class="shm-dp-inf-item-bar-wrap">
                        <div class="shm-dp-inf-item-bar"
                             [style.width.%]="item.score * 100"
                             [style.background]="tagColor(prod.tag)"></div>
                      </div>
                      <span class="shm-dp-inf-item-score">{{ item.score.toFixed(2) }}</span>
                    </div>
                  }
                }
              }
            } @else {
              <div class="shm-dp-inf-empty">Sin detecciones</div>
            }
          </div>

        </aside>

      </div>
      }

      <!-- ══ TAB: PRODUCTOS ══ -->
      @if (storeDetailTab === 'products') {
        <div class="shm-dp-products">
          @if (storeSummary.topProducts.length) {
            <div class="shm-dp-products-grid">
              @for (p of storeSummary.topProducts; track p.name) {
                <div class="shm-dp-prod-card" [style.--tag-color]="tagColor(p.tag)">
                  <div class="shm-dp-prod-card__head">
                    <span class="shm-dp-prod-card__dot" [style.background]="tagColor(p.tag)"></span>
                    <span class="shm-dp-prod-card__tag">{{ p.tag }}</span>
                  </div>
                  <strong class="shm-dp-prod-card__name">{{ p.name }}</strong>
                  <div class="shm-dp-prod-card__foot">
                    <span class="shm-dp-prod-card__count">{{ p.count }}</span>
                    <span class="shm-dp-prod-card__label">caras</span>
                  </div>
                </div>
              }
            </div>
          } @else {
            <div class="shm-dp-empty">Sin productos detectados.</div>
          }
        </div>
      }

      <!-- ══ TAB: RESUMEN — desactivado temporalmente ══ -->

    </div>
  }

</div>
  